import store from '@/store';
import { LocalesDictionary } from '@/store/modules/i18n';
import { ErrorCode } from '@/resources/error/ErrorCode';
import ApiModalError from '@/resources/error/ApiModalError';
import i18n from '@/i18n';

export const checkCorrectLocales = async (localesDictionary: LocalesDictionary): Promise<void> => {
  // 対応すべき言語が受け取った連想配列に全て含まれているか確認
  if (i18n.availableLocales.every((locale: string): boolean => locale in localesDictionary)) return;

  // エラーをthrowすることにより、main.tsのVue.config.errorHandlerでエラーを受け取り、サーバにエラーログを送る。
  // 下記addApiError命令において、本来はエラー表示処理中はawaitしたいが、
  // redirectエラーはnextを実行せず処理がこちらまで戻ってこない。
  // redirectエラーでもnextを実行するようにしたいが、影響がすぐには読めないので、
  // ここではとりあえずawaitせずにエラーをthrowする。
  new Promise<boolean>((resolve: (isRetry: boolean) => void): void => {
    store.dispatch('error/addApiError', {
      type: 'redirect',
      code: ErrorCode.UnexpectedLocaleInfomation,
      next: resolve
    });
  });
  throw new Error(`${ErrorCode.UnexpectedLocaleInfomation} location error`);
};
